import React from "react";
import { Box, FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText } from "@mui/material";
import { styled } from "@mui/system";

const CenteredBox = styled(Box)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "10px",
    padding: "0px",
  });

const Filters = ({ filters, setFilters, filterOptions }) => {
  const handleFilterChange = (event, key) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [key]: event.target.value,
    }));
  };

  return (
    <CenteredBox>
      {Object.keys(filterOptions).map((key) => (
        <FormControl key={key} style={{ minWidth: 200 }}>
          <InputLabel>{key}</InputLabel>
          <Select
            multiple
            value={filters[key]}
            onChange={(event) => handleFilterChange(event, key)}
            renderValue={(selected) => selected.join(", ")}
          >
            {filterOptions[key].map((option) => (
              <MenuItem key={option} value={option}>
                <Checkbox checked={filters[key].includes(option)} />
                <ListItemText primary={option} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ))}
    </CenteredBox>
  );
};

export default Filters;
